import { useEffect } from 'react';

import CheckboxComp from 'wa-storybook/components/inputs/checkbox-comp/checkbox-comp';

import { ControlledFormikCheckboxProps } from './types';

export type CheckboxFieldProps = ControlledFormikCheckboxProps & {
  labelClassName?: string;
  titleClassName?: string;
  validateOnChange?: boolean;
};

const CheckboxField = ({
  field,
  form,
  label,
  labelClassName,
  parentStateValue,
  setParentAndFormikStateValue,
  reverseDirection,
  titleClassName,
  validateOnChange = false,
}: CheckboxFieldProps) => {
  const isControlledComponent =
    parentStateValue !== null && parentStateValue !== undefined;
  // We set the formik value to the parent state value, when/if it first comes into view
  // (otherwise the form will submit it as the dafault formik value, regardless of how the parent state has it appearing).
  // This ensures that the formik state is consistent with parent state, from the start.
  useEffect(() => {
    if (isControlledComponent) {
      setParentAndFormikStateValue(parentStateValue, form);
    }
  }, []);

  return (
    <CheckboxComp
      titleClassName={titleClassName}
      labelClassName={labelClassName}
      id={field.name}
      ariaDescribedBy={`${field.name}-description`}
      isChecked={isControlledComponent ? parentStateValue : field.value}
      handleChange={event => {
        if (isControlledComponent) {
          setParentAndFormikStateValue(!parentStateValue, form);
        } else {
          form.setFieldValue(
            field.name,
            event.target.checked,
            validateOnChange,
          );
        }
      }}
      label={label}
      reverseDirection={reverseDirection}
    />
  );
};

export default CheckboxField;
